import { render, staticRenderFns } from "./ViewGroupSubGroups.vue?vue&type=template&id=5b3471b2&scoped=true&"
import script from "./ViewGroupSubGroups.vue?vue&type=script&lang=js&"
export * from "./ViewGroupSubGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3471b2",
  null
  
)

export default component.exports